// @flow
import React from "react"
import {
  compose,
  withStateHandlers,
  withHandlers,
  withState,
  type HOC,
} from "recompose"
import withConnect from "hoc/withConnect"
import withRouter from "hoc/withRouter"
import Calendar from "components/Calendar"
import Button from "components/Button"
import { Wrap } from "componentsStyled/Layout/Wrap"
import { type Error as ErrorType } from "components/Calendar/ErrorMessage"
import {
  pickReservationDates,
  pickOriginalReservation,
} from "data/reservations/actions"
import type { DateRange, DateRangeValue, DateString } from "data/units/date/types"
import { dateRangeFromValue } from "data/units/date/helpers"
import type {
  ProductVariant,
  ProductVariantAvailableAffiliate,
} from "data/product/types"
import { clearAvailability } from "data/reservations/actions"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import Price from "./Price"
import { setActiveDates, resetDates } from "./helpers"

const ProductAvailabilityModal = ({
  handleClose,
  value,
  setDay,
  handleClear,
  handleClearEvent,
  handleError,
  errorMessage,
  productVariant,
  variantAffiliate,
  handlePickDates,
  originalReservation,
}) => {
  const dates = dateRangeFromValue(value)

  return (
    <ModalBody close={handleClose} wide>
      <ModalHeader close={handleClose} title="Dates" clear={handleClearEvent} />
      <ModalContent>
        <Wrap>
          <Calendar
            closeModal={handleClose}
            onChange={setDay}
            onError={handleError}
            errorMessage={errorMessage}
            value={value}
            variantAffiliate={variantAffiliate}
            availabilityVariables={{
              productVariantId: productVariant.id,
              affiliateId: variantAffiliate.affiliateId,
            }}
            originalReservation={originalReservation}
            clear={handleClear}
          />
        </Wrap>
      </ModalContent>
      <ModalControls>
        <Price
          variantAffiliate={variantAffiliate}
          dates={dates}
          originalReservation={originalReservation}
        />
        <Button disabled={!dates} onClick={handlePickDates}>
          {originalReservation ? "Extend Reservation" : "Reserve"}
        </Button>
      </ModalControls>
    </ModalBody>
  )
}

type Outter = {|
  close: Function,
  callback?: Function,
  productVariant: ProductVariant,
  variantAffiliate: ProductVariantAvailableAffiliate,
  originalReservation?: DateRange,
|}

const mapDispatchToProps = {
  pickOriginalReservation,
  pickReservationDates,
  clearAvailability,
}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withConnect(() => ({}), mapDispatchToProps),
  withStateHandlers(
    { errorMessage: undefined },
    {
      handleError: () => (e: ?ErrorType) => ({ errorMessage: e }),
      clearError: () => () => ({ errorMessage: undefined }),
    },
  ),
  withState(
    "value",
    "setValue",
    ({ originalReservation }) => setActiveDates(originalReservation),
  ),
  withHandlers({
    handlePickDates: props => () => {
      const dates = dateRangeFromValue(props.value)
      if (dates) {
        if (props.originalReservation) {
          props.pickOriginalReservation(props.originalReservation)
        }
        props.pickReservationDates(dates, props.productVariant)
        props.callback()
        props.close()
      }
    },
    setDay: props => (v: DateRangeValue) => {
      props.clearError()
      props.setValue(v)
    },
    handleClear: props => (v?: DateString) => {
      resetDates(props, v)
    },
    handleClearEvent: props => (e: SyntheticEvent<HTMLButtonElement>) => {
      resetDates(props)
    },
    handleClose: props => () => {
      props.close()
      props.clearAvailability()
    },
  }),
)

export default enhancer(ProductAvailabilityModal)



// WEBPACK FOOTER //
// ./src/modals/ProductAvailability/index.js